var map = {
	"./cs.json": [
		89325,
		89325
	],
	"./en.json": [
		58988,
		58988
	],
	"./ja.json": [
		14714,
		14714
	],
	"./ru.json": [
		98750,
		98750
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 7054;
module.exports = webpackAsyncContext;